import type { ReactNode } from 'react'
import type { RenderEntityList as InsightEntityList } from '../../../insightRenderLists'
import { Note } from '../InsightsBlocks'
import { InsightEntityNames } from './InsightEntityNames'
import { useAppBridge } from '@shopify/app-bridge-react'
import { trackShopifyAction } from '../../../shopifyUiTracking'
export function formatEntityListDatum(d: InsightEntityList['rows'][number]['summary']) {
  const unit = d.value === 1 ? d.unit.slice(0, -1) : d.unit
  return `${d.value.toLocaleString('en-AU', { maximumFractionDigits: d.unit === 'days' ? 1 : 0 })} ${unit}`
}
export function EntityListDetailsModal({
  id,
  list,
  context,
  rowContent,
}: {
  id: string
  list: InsightEntityList
  context: string
  rowContent?: Record<string, ReactNode>
}) {
  const shopify = useAppBridge()
  return (
    <s-modal id={id} heading={list.title} data-insight-list={list.id}>
      <s-stack gap="base">
        {list.rows.map((row) => (
          <s-stack key={row.id} gap="small" data-insight-row={row.id}>
            <s-text fontWeight="semibold">
              <InsightEntityNames entities={row.entities} separator=" → " />
            </s-text>
            {row.details.map((d) => (
              <s-grid key={d.label} gridTemplateColumns="minmax(0, 1fr) auto" gap="small">
                <s-text>{d.label}</s-text>
                <s-text fontWeight="medium">{formatEntityListDatum(d)}</s-text>
              </s-grid>
            ))}
            <Note>{row.note}</Note>
            {rowContent?.[row.id]}
            <s-divider />
          </s-stack>
        ))}
        <Note>{list.footer}</Note>
        <Note>{context}</Note>
      </s-stack>
      <s-button
        slot="secondary-actions"
        commandFor={id}
        command="--hide"
        onClick={() => trackShopifyAction(shopify, 'close-patterns', () => undefined)}
      >
        Close
      </s-button>
    </s-modal>
  )
}
